import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  form: {
    width: '100%',
    height: '100%',
    flex: 1,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: SPACES.xxxxxl,
  },
  uploadWrapper: {
    display: 'flex',
    flexDirection: 'column',

    gap: SPACES.m,
    alignItems: 'center',
  },
  submitWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  filename: {
    maxWidth: 200,
    display: 'block',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  styleLink: {
    display: 'flex',
    alignItems: 'center',
  },
}))
